import { Paper } from "@mui/material";
import { Settings } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { IUser, UserRole } from "@framework/types";
import { useUser } from "@dzambalaorg/provider-user";
import { List } from "@dzambalaorg/ui-kit";

export const SettingsSection = () => {
  const { profile } = useUser<IUser>();

  if (!profile.userRoles.includes(UserRole.SUPER)) {
    return null;
  }

  return (
    <Paper sx={{ mb: 2 }}>
      <List
        component="nav"
        subheader={
          <List.Subheader>
            <FormattedMessage id="pages.dashboard.settings.title" />
          </List.Subheader>
        }
      >
        <List.ItemButton<typeof RouterLink> component={RouterLink} to="/featureFlags">
          <List.ItemIcon>
            <Settings />
          </List.ItemIcon>
          <List.ItemText>
            <FormattedMessage id="pages.dashboard.settings.featureFlags" />
          </List.ItemText>
        </List.ItemButton>
      </List>
    </Paper>
  );
};
